import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';
import {state} from './state';

// Export site store
export const site = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
